export default {
  name: "ASB Solo Check",
  description: "Check for Anti-Social Behaviour (Solo) vehicle before and after duty.",
  required: ["Name", "LicensePlate", "Mileage"],
  fields: [
    { key: "Name", label: "Name", type: "text", required: true },
    { key: "Date", label: "Date", type: "date" },
    { key: "Department", label: "Department", type: "text" },
    { key: "LicensePlate", label: "Vehicle Number Plate", type: "text", required: true },
    { key: "Mileage", label: "Mileage", type: "number", required: true },
    { key: "Destination", label: "Destination / Route", type: "text" },
    { key: "Cleanliness", label: "Cleanliness of Vehicle", type: "text" },
    { key: "Damage", label: "Any Visible Damage", type: "text" },
    { key: "Equipment", label: "Check ASB Kit / Equipment Present", type: "text" },
    { key: "Notes", label: "Additional Notes", type: "textarea" }
  ],
  photos: true
};
